import { Routes, Route, Navigate } from 'react-router-dom';
import LeadWorkspace from './pages/LeadWorkspace';
import LeadManagement from './pages/LeadManagement';
import LeadImport from './pages/LeadImport';
import LeadAnalytics from './pages/LeadAnalytics';
import LeadTypesAdmin from './pages/LeadTypesAdmin';
import LeadSourcesAdmin from './pages/LeadSourcesAdmin';
import LeadStatusesAdmin from './pages/LeadStatusesAdmin';
import PermissionRoute from '../../routes/PermissionRoute';

const LeadRoutes = () => (
  <Routes>
    <Route path="/" element={<PermissionRoute requiredPermissions={[{ module: 'myLeads', action: 'view' }]}><LeadWorkspace /></PermissionRoute>} />
    <Route path="workspace" element={<PermissionRoute requiredPermissions={[{ module: 'myLeads', action: 'view' }]}><LeadWorkspace /></PermissionRoute>} />
    <Route path="manage" element={<PermissionRoute requiredPermissions={[{ module: 'leadManagement', action: 'view' }]}><LeadManagement /></PermissionRoute>} />
    <Route path="import" element={<PermissionRoute requiredPermissions={[{ module: 'importLeads', action: 'view' }]}><LeadImport /></PermissionRoute>} />
    <Route path="analytics" element={<PermissionRoute requiredPermissions={[{ module: 'leadAnalytics', action: 'view' }]}><LeadAnalytics /></PermissionRoute>} />
    <Route path="types" element={<PermissionRoute requiredPermissions={[{ module: 'leadTypes', action: 'view' }]}><LeadTypesAdmin /></PermissionRoute>} />
    <Route path="sources" element={<PermissionRoute requiredPermissions={[{ module: 'leadSources', action: 'view' }]}><LeadSourcesAdmin /></PermissionRoute>} />
    <Route path="statuses" element={<PermissionRoute requiredPermissions={[{ module: 'leadStatuses', action: 'view' }]}><LeadStatusesAdmin /></PermissionRoute>} />
    <Route path="*" element={<Navigate to="/leads" replace />} />
  </Routes>
);

export default LeadRoutes;
